import { render, staticRenderFns } from "./decisionManagement.vue?vue&type=template&id=b179a6cc&scoped=true"
import script from "./decisionManagement.vue?vue&type=script&lang=js"
export * from "./decisionManagement.vue?vue&type=script&lang=js"
import style0 from "./decisionManagement.vue?vue&type=style&index=0&id=b179a6cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b179a6cc",
  null
  
)

export default component.exports